export const AUTO_SLIDE_DURATION_IN_SECS = 3;
